import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreIssueTypesRoute: InvariantJiraRoute = {
	name: 'project-settings-core-issuetypes',
	path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?',
	exact: true,
};
